// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { welcomeHomeStyles } from "@west/App/Widgets/Home/WelcomeHome";
import Edit from "@west/XDL/Icons/Edit";
import { xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

welcomeHomeStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 22px;
    `,
};

welcomeHomeStyles.welcomeContainer = {
    css: css`
        display: flex;
        align-items: flex-end;
        flex-wrap: wrap;
        gap: 14px 24px;
        ${xScreen("lte", "xs")} {
            flex-direction: column;
            flex-wrap: nowrap;
            align-items: flex-start;
        }
    `,
};

welcomeHomeStyles.title = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
    `,
};

welcomeHomeStyles.message = {
    color: "text.main",
    icon: {
        iconProps: {
            src: Edit,
            size: 12,
            color: "common.ui8",
            css: css`
                opacity: 0.66;
            `,
        },
    },
    css: css`
        margin-bottom: 4px;
    `,
};
